import { FC, useState } from 'react';
import { Button } from '../../components/button/button';
import { Tabs, TabType } from '../../components/tabs/tabs';
import { useLang } from '../../hooks/use-lang';
import { WorkingHoursInterface } from './types';
import { WorkingHoursSpecs } from './working-hours-specs/working-hours-specs';
import { WorkingHoursWeek } from './working-hours-week/working-hours-week';
import s from './working-hours.module.css';

export const WorkingHours: FC<WorkingHoursInterface> = (props) => {
  const { handleUpdateSpecs, data, handleUpdateWeek, handleSave } = props;
  const { t } = useLang();

  const tabs: TabType[] = [
    {
      id: 'week',
      label: t('Ежедневно'),
    },
    {
      id: 'specs',
      label: t('Специальные дни'),
    },
  ];

  const [activeTab, setActiveTab] = useState<TabType>(tabs[0]);

  return (
    <div className={s.feature}>
      <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} fullWidth />
      {activeTab.id === 'week' && (
        <WorkingHoursWeek week={data?.week} handleUpdateWeek={handleUpdateWeek} />
      )}
      {activeTab.id === 'specs' && (
        <WorkingHoursSpecs specs={data?.specs} handleUpdateSpecs={handleUpdateSpecs} />
      )}
      {handleSave && (
        <div className={s.buttons}>
          <Button onClick={handleSave} data-testid="save-button">
            {t('Сохранить')}
          </Button>
        </div>
      )}
    </div>
  );
};
